import { FC } from 'react'

import styled from 'styled-components'

import { hidePartOfEmailWithStars } from 'src/Constants/functions'
import { PrimaryDottedButton } from 'src/Components/Buttons/PrimaryDottedButton'
import { PrimaryButton } from 'src/Components/Buttons/PrimaryButton'
import SuccessIcon from 'src/Assets/Svg/pages-icons/Success.svg?react'

const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  align-self: stretch;
`

const ConfirmationText = styled.div`
  color: ${(props) => props.theme.color.darkGrey};
  text-align: center;
  font-family: 'Segoe UI';
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: 150%;
`

const Center = styled(ConfirmationText)`
  font-size: 14px;
  font-weight: 400;
`

const ButtonsWrapper = styled.div`
  display: flex;
  justify-content: center;
  gap: 16px;
  align-items: center;
`

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 40px;
  align-self: stretch;
`
const StyledSuccessIcon = styled(SuccessIcon)`
  color: ${({ theme }) => theme.color.brandGreen};
`

const StyledPrimaryButton = styled(PrimaryButton)`
  padding-left: 40px;
  padding-right: 40px;
`

interface LoginCreatorConfirmationProps {
  email: string
  onClickSendAgain: () => void
  onClickChangeEmail: () => void
  isSending: boolean
}

export const LoginCreatorConfirmation: FC<LoginCreatorConfirmationProps> = ({
  onClickSendAgain,
  email,
  onClickChangeEmail,
  isSending,
}) => (
  <Container>
    <StyledSuccessIcon width={40} height={40} />
    <TextContainer>
      <ConfirmationText>
        Confirmation link sent to &nbsp;
        {hidePartOfEmailWithStars(email)}
      </ConfirmationText>
      <Center>
        Check your inbox and click the link to access your dashboard.
      </Center>
    </TextContainer>
    <ButtonsWrapper>
      <PrimaryDottedButton onClick={onClickChangeEmail}>
        Change email
      </PrimaryDottedButton>
      <StyledPrimaryButton disabled={isSending} onClick={onClickSendAgain}>
        Resend link
      </StyledPrimaryButton>
    </ButtonsWrapper>
  </Container>
)
